import { ecsApi } from '@services/providers/ecs';
import { eventEmitter } from '@utils';
import { News } from './news.types';

export const newsApi = ecsApi.injectEndpoints({
    endpoints: (builder) => ({
        getNews: builder.mutation<News[], void>({
            query: () => ({
                url: '/news',
                method: 'GET'
            })
        }),
        markNewsAsSeen: builder.mutation<{ message: string }, string | number>({
            query: (id) => ({
                url: '/news',
                method: 'POST',
                body: { id_news: id }
            }),
            onQueryStarted: async (_id, { queryFulfilled }) => {
                try {
                    await queryFulfilled;
                    eventEmitter.emit('news:updated');
                } catch {
                    // No-op: errors surface via the base query error handling.
                }
            }
        }),
        markAllNewsAsSeen: builder.mutation<{ message: string }, void>({
            query: () => ({
                url: '/news/seen-all',
                method: 'PUT'
            }),
            onQueryStarted: async (_arg, { queryFulfilled }) => {
                try {
                    await queryFulfilled;
                    eventEmitter.emit('news:updated');
                } catch {
                    // No-op: errors surface via the base query error handling.
                }
            }
        })
    })
});

export const { useGetNewsMutation, useMarkNewsAsSeenMutation, useMarkAllNewsAsSeenMutation } = newsApi;
